import React from 'react';
import { ConfigClientType } from '../types/ConfigClientType';
import { getTranslation } from '../../constants/languages';

type WcbNumberContainerProps = {
    iimclient: ConfigClientType;
    wcbNumber?: string;
    wcbNumberErrorVisible: boolean;
    changeCallbackNumber: Function;
};

const TranslationsCallNumber = {
    lang_no: 'Ditt telefonnummer',
    lang_fi: 'Anna puhelinnumero',
    lang_se: null,
    lang_dk: 'Indtast dit telefonnummer',
    lang_en: null,
};

const TranslationsPhoneValidation = {
    lang_no: 'Fyll inn et 8-sifret nummer',
    lang_fi: null,
    lang_se: null,
    lang_dk: null,
    lang_en: null,
};

const WcbNumberContainer = ({
    iimclient,
    wcbNumber,
    wcbNumberErrorVisible,
    changeCallbackNumber,
}: WcbNumberContainerProps) => {
    const { lang, phoneValidationError } = iimclient;

    const validationErrorLabel =
        phoneValidationError || getTranslation(lang, TranslationsPhoneValidation);
    const callNumberPlaceholder = getTranslation(lang, TranslationsCallNumber);

    const handleOnChange = ({ target }) => changeCallbackNumber(target.value);

    return (
        <div className="input-block wcb-phone-container helpinput">
            <label htmlFor="callbackNumber" id="callbackNumberLbl">
                {callNumberPlaceholder}
            </label>
            <input
                id="callbackNumber"
                name="callbackNumber"
                type="tel"
                className="if input-field"
                aria-labelledby="wcb-callbackNumberLbl"
                value={wcbNumber}
                onChange={handleOnChange}
            />
            {wcbNumberErrorVisible && (
                <div className="validation-error">
                    <span className="validationerror">{validationErrorLabel}</span>
                </div>
            )}
        </div>
    );
};

export default WcbNumberContainer;
